import * as STD from '@emersya/mpa-std';
import * as CM  from '@emersya/mpa-components-manager';

export type TTextTypes = (
	'title-1' | 'title-2' | 'title-3' | 'title-4' | 'title-5' | 'title-6' |
	'label' |
	'paragraph' |
	'block' |
	'block-inline'
	);
export type TDOMRepresentation = HTMLDivElement | HTMLParagraphElement | HTMLHeadingElement | HTMLLabelElement;

export interface ITextComponentConfigurationBase extends CM.DOMComponent.IConfiguration {
	type?: string;
	asHTML?: boolean;
};

export interface ITextComponentConfigurationStandard extends ITextComponentConfigurationBase {
	type?: Exclude<TTextTypes, 'label'>;
};

export interface ITextComponentConfigurationLabel extends ITextComponentConfigurationBase {
	type: 'label';
	target?: CM.Path.TPathRaw
};

export type TTextComponentConfiguration = ITextComponentConfigurationStandard | ITextComponentConfigurationLabel;

export class TextComponent extends CM.DOMComponent<
	TDOMRepresentation,
	TextComponent,
	TTextComponentConfiguration
> {
	component_DOM: TDOMRepresentation;
	text: string | null = null;

	/**
	 * Do not call update if you use translation.
	 **/
	update(text: string) {
		if (this.component_configuration.asHTML) {
			this.component_DOM.innerHTML = text;
		} else {
			this.component_DOM.textContent = text;
		}
		delete this.component_DOM.dataset.translation;
		this.text = text;
	};

	override async component_initialize() {
		await super.component_initialize();

		if (this.component_configuration.type === 'label' && this.component_configuration.target) {
			const target = this.component_find(this.component_configuration.target);
			this.component_DOM.setAttribute('for', (<CM.DOMComponent<any, any, any>>target).getDOMId());
		}
	}

	override async component_finalize() {
		await super.component_finalize();
		if (this.component_hasTranslation('text')) {
			const trId = this.component_getTranslationId('text');
			this.component_DOM.dataset.translation = trId;
			this.text = '\0' + trId;
		} else if (this.component_configuration['@stringData']) {
			this.update(this.component_configuration['@stringData']);
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: TTextComponentConfiguration
	) {
		super(descriptor, configuration);
		if (!this.component_configuration.type) {
			this.component_configuration.type = 'block';
		}
		if (this.component_configuration.type === 'label') {
			this.component_DOM = <HTMLLabelElement>STD.DOM.factory({tag: 'label'});
		} else if (this.component_configuration.type === 'paragraph') {
			this.component_DOM = <HTMLDivElement>STD.DOM.factory({tag: 'p'});
		} else if (this.component_configuration.type === 'block') {
			this.component_DOM = <HTMLDivElement>STD.DOM.factory({});
		} else if (this.component_configuration.type === 'block-inline') {
			this.component_DOM = <HTMLDivElement>STD.DOM.factory({tag: 'span'});
		} else if (this.component_configuration.type.startsWith('title-')) {
			this.component_DOM =
				<HTMLDivElement>STD.DOM.factory({tag: this.component_configuration.type.replace('title-', 'h')});
		} else {
			this.component_throwUserError('Invalid configuration.type value!', {
				'configuration.type': this.component_configuration.type
			});
		}
		if (this.component_configuration.asHTML) {
			this.component_DOM.setAttribute('translation-as-html', '');
		}
	};
};
export namespace NS {
	export type Component = TextComponent;
	export const Component = TextComponent;
	export type Configuration = TTextComponentConfiguration;
}
;
CM.Manager.declare({
	id: 'text',
	type: TextComponent
});
